import React, { useState, useEffect } from "react";
import { Box, Typography, Container, Paper } from "@mui/material";
import SimpleLayout from "../../common/layouts/SimpleLayout";
import styles from "./OrderStatus.module.scss";
import { InputField } from "../../common/theme/Input";
import { OrderStatusIcon } from "../../assets/Icons/icons";
import AppButton from "../../common/theme/Button";
import OrderDetails from "./OrderDetails";
import { useFormik } from "formik";
import * as Yup from "yup";
import useFetch from "../../customHook/useFetch";
import {
  BASE_CRYPTO_SECRET,
  DIRECT_ACCESS_URL,
} from "../../constants/constants";
import { toast } from "react-toastify";
import { RotatingLines } from "react-loader-spinner";
import { useSearchParams } from "react-router-dom";
import CryptoJS from "crypto-js";
const OrderStatus = () => {
  const secretKey: any = BASE_CRYPTO_SECRET;
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [loading, setLoading] = useState(true);

  /** Get direct access url */
  const direct_access_url = DIRECT_ACCESS_URL;
  const [orderDetail, setOrderDetail] = useState<any>(null);

  /** Api Call */
  /** Get order status */
  const [
    getOrderStatus,
    { response: orderStatusRes, loading: orderStatusLoading },
  ] = useFetch(`/get-order-status/${direct_access_url}`, {
    method: "post",
  });
  /** Api Call End */

  /** Formik */
  const handleSubmit = (values: { email: string; order_number: string }) => {
    getOrderStatus(values);
    // Handle form submission here
  };
  const formik = useFormik({
    initialValues: {
      email: "",
      order_number: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      order_number: Yup.string()
        .matches(/^[0-9]+$/, "Order number must contain only digits")
        .required("Order number is required"),
    }),
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });
  /** Formik End */

  /** Use Effect */
  useEffect(() => {
    if (orderStatusRes) {
      if (orderStatusRes?.status) {
        setOrderDetail(orderStatusRes.data);
        setLoading(false);
      } else {
        toast.dismiss();
        toast.error(orderStatusRes?.message);
        setLoading(false);
      }
    }
  }, [orderStatusRes]);
  /** Use Effect End */

  useEffect(() => {
    if (token && secretKey) {
      setLoading(true);
      const decodeDataToString = CryptoJS.enc.Hex.parse(token);
      const decodeDataToString1 = decodeDataToString.toString(
        CryptoJS.enc.Base64
      );
      const decryptText = CryptoJS.AES.decrypt(decodeDataToString1, secretKey);
      const originalText = decryptText.toString(CryptoJS.enc.Utf8);
      const reportData = JSON.parse(originalText);
      const payload = {
        email: reportData.email,
        order_number: reportData.order_id,
      };
      getOrderStatus(payload);
    } else {
      setLoading(false);
    }
  }, []);
  return (
    <SimpleLayout>
      {loading ? (
        <></>
      ) : orderDetail ? (
        <OrderDetails orderData={orderDetail} setOrderDetail={setOrderDetail} />
      ) : (
        <>
          <div className={styles.headerSection} />
          <Container
            className={styles.orderStatusContainer}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: { xs: 2, sm: 4 },
              minHeight: "100vh",
            }}
          >
            <Box
              className={styles.formContainer}
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              {/* Icon */}
              <Box
                className={styles.iconContainer}
                sx={{ mb: { xs: 2, sm: 3 } }}
              >
                {OrderStatusIcon}
              </Box>

              {/* Title */}
              <Typography
                variant="h4"
                component="h1"
                gutterBottom
                className={styles.title}
                sx={{ mb: { xs: 2, sm: 4 } }}
              >
                Check Order Status
              </Typography>

              {/* Form */}
              <Paper
                elevation={0}
                sx={{
                  width: "100%",
                  p: { xs: 2, sm: 3 },
                  borderRadius: { xs: 2, sm: 3 },
                }}
              >
                <form onSubmit={formik.handleSubmit}>
                  <Box sx={{ mb: { xs: 2, sm: 3 } }}>
                    <InputField
                      formik={formik}
                      name="email"
                      label={"Email Address"}
                      placeholder={`Enter your email address`}
                    />
                  </Box>

                  <Box sx={{ mb: { xs: 2, sm: 3 } }}>
                    <InputField
                      formik={formik}
                      name="order_number"
                      label={"Order Number"}
                      placeholder={`Enter your order number`}
                    />
                  </Box>

                  <AppButton
                    type="submit"
                    style={{ cursor: "pointer", width: "100%" }}
                    disabled={orderStatusLoading}
                    variant="contained"
                    color={"primary"}
                  >
                    {orderStatusLoading ? (
                      <span className="loadingBars">
                        <RotatingLines
                          strokeColor="currentColor"
                          strokeWidth="5"
                          animationDuration="0.75"
                          width="20"
                        />
                      </span>
                    ) : (
                      ""
                    )}{" "}
                    View Order Status
                  </AppButton>
                </form>
              </Paper>
            </Box>
          </Container>
        </>
      )}
    </SimpleLayout>
  );
};

export default OrderStatus;
